import React, { PropTypes, Component } from 'react'

import ServicePenalty from 'components/ServicePenalty'

class RecurrenceModificationPenalty extends Component {
  componentDidMount () {
    this.fetchPenalty()
  }

  shouldComponentUpdate (nextProps) {
    const isDifferentPenalty = this.props.penalty !== nextProps.penalty

    return isDifferentPenalty
  }

  componentDidUpdate () {
    const { penalty, onPenaltyFetched } = this.props
    const penaltyFetched = penalty.hasOwnProperty('message')
    if (penaltyFetched) {
      onPenaltyFetched()
    }
  }

  fetchPenalty () {
    const { recurrenceId, recurrenceModifications, fetchPenalty } = this.props
    fetchPenalty(recurrenceId, recurrenceModifications)
  }

  render () {
    const { penalty } = this.props
    return (
      <ServicePenalty penalty={penalty} />
    )
  }
}

RecurrenceModificationPenalty.displayName = 'RecurrenceModificationPenalty'
RecurrenceModificationPenalty.propTypes = {
  recurrenceId: PropTypes.number.isRequired,
  recurrenceModifications: PropTypes.object.isRequired,
  fetchPenalty: PropTypes.func.isRequired,
  penalty: PropTypes.object.isRequired
}

export default RecurrenceModificationPenalty



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/shared/components/RecurrenceModificationPenalty/RecurrenceModificationPenalty.js